import { render, staticRenderFns } from "./CoinListSmall.vue?vue&type=template&id=53065601&scoped=true&"
import script from "./CoinListSmall.vue?vue&type=script&lang=ts&"
export * from "./CoinListSmall.vue?vue&type=script&lang=ts&"
import style0 from "./CoinListSmall.vue?vue&type=style&index=0&id=53065601&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53065601",
  null
  
)

export default component.exports